import React, { useEffect, useState } from 'react'

import { NoticeBox, NoticeBoxColors, VsExclamationIcon } from '@octane/spark'
import { useFeatureFlagContext } from 'contexts/FeatureFlagContextProvider'
import useUser from 'hooks/useUser'
import styled from 'styled-components'

const Container = styled.div<{ margin: string }>`
    width: 100%;
    margin-bottom: 20px;
    padding: ${(props) => props.margin};
    > div {
        align-items: center;
    }
`

export default function RoadrunnerDealershipAgreementNotice(props: {
    margin?: string
}) {
    const { user } = useUser()
    const { margin } = props

    const [
        isAgreementSignedWithRoadrunner,
        setIsAgreementSignedWithRoadrunner,
    ] = useState<boolean>()

    const dealershipLenderAgreementValidation =
        useFeatureFlagContext()?.dealershipLenderAgreementValidation

    useEffect(() => {
        setIsAgreementSignedWithRoadrunner(
            user?.dealership?.isAgreementSignedWithRoadrunner,
        )
    }, [user?.dealership?.isAgreementSignedWithRoadrunner])

    const showRoadrunnerDealershipAgreementNotice =
        isAgreementSignedWithRoadrunner === false &&
        dealershipLenderAgreementValidation

    return showRoadrunnerDealershipAgreementNotice ? (
        <Container margin={margin ?? '0'}>
            <NoticeBox
                variant="box"
                icon={VsExclamationIcon}
                color={NoticeBoxColors.ERROR}
                content={
                    <>
                        In order to proceed with submitting a credit
                        application, the dealership must have an electronically
                        signed dealer agreement with Roadrunner Financial
                    </>
                }
            />
        </Container>
    ) : null
}
